import { render, staticRenderFns } from "./PlotlySprayChartExample.vue?vue&type=template&id=13c6342a"
import script from "./PlotlySprayChartExample.js?vue&type=script&lang=js&external"
export * from "./PlotlySprayChartExample.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports